import React from "react";

function TasksPanelMob(props) {
  return <div>TasksPanelMob</div>;
}

export default TasksPanelMob;
